import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { Card } from "react-bootstrap";

const PostSkeleton = () => {
  return (
    <Card className="shadow-sm mb-4">
      <Card.Body>
        {/* Header */}
        <div className="d-flex align-items-center justify-content-between mb-3">
          <div className="d-flex align-items-center">
            <Skeleton circle width={43} height={43} className="me-2" />
            <div className="d-flex flex-column">
              <Skeleton width={120} height={16} />
              <Skeleton width={80} height={12} className="mt-1" />
            </div>
          </div>
          <div className="d-flex align-items-center">
            <Skeleton width={80} height={30} className="rounded-5" />
            <i className="fas fa-ellipsis-v ms-3 fa-lg text-muted"></i>
          </div>
        </div>

        {/* Caption */}
        <Skeleton count={2} height={12} className="mb-3" />

        {/* Image */}
        <Skeleton height={250} className="mb-3" />

      </Card.Body>

      <Card.Footer className="text-muted">
        <div className="d-flex align-items-center justify-content-between">
          <div className="d-flex gap-4">
            <Skeleton width={60} height={20} />
            <Skeleton width={60} height={20} />
          </div>
          <Skeleton width={80} height={10} />
        </div>
      </Card.Footer>
    </Card>
  );
};

export default PostSkeleton;
